module.exports = __webpack_public_path__ + "static/media/flap_pockets.fc8c362b.svg";